module.exports = __webpack_public_path__ + "agere.jpg?8525f4876e126169ea2a46ffa16bc7cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/agere.jpg
// module id = 99
// module chunks = 0